import apiMiddleware from "../../../api/apiMiddleware";

// List activity categories with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `activity-categories?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// Create activity category
const create = async (data) => {
  const response = await apiMiddleware.post("activity-categories", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

// Get activity category by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`activity-categories/${id}`);
  return response.data;
};

// Update activity category
const update = async ({ id, data }) => {
  const response = await apiMiddleware.post(
    `activity-categories/${id}?_method=PUT`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

// Delete activity category
const deleteActivityCategory = async (id) => {
  const response = await apiMiddleware.delete(`activity-categories/${id}`);
  return response.data;
};

export { list, create, getById, update, deleteActivityCategory };
